import type { IntlShape } from 'react-intl';

/**
 * Header search placeholder copy: the static placeholder, the typewriter prefix, and
 * the localized example terms cycled in the animated placeholder.
 */
export function getSearchPlaceholder(intl: IntlShape) {
  const staticPlaceholder = intl.formatMessage({
    id: 'component.client.navigation.header.searchPopover.placeholder',
    defaultMessage: 'Co hledáte? Např. dron či RC auto',
  });

  const typewriterPrefix = intl.formatMessage({
    id: 'component.client.navigation.header.searchPopover.placeholderPrefix',
    defaultMessage: 'Co hledáte? Např.',
  });

  const typewriterPhrases = [
    intl.formatMessage({
      id: 'component.client.navigation.header.searchPopover.typewriter.drone',
      defaultMessage: 'dron',
    }),
    intl.formatMessage({
      id: 'component.client.navigation.header.searchPopover.typewriter.rcCar',
      defaultMessage: 'RC auto',
    }),
    intl.formatMessage({
      id: 'component.client.navigation.header.searchPopover.typewriter.battery',
      defaultMessage: 'baterie',
    }),
    intl.formatMessage({
      id: 'component.client.navigation.header.searchPopover.typewriter.helicopter',
      defaultMessage: 'helikoptéra',
    }),
  ];

  return { staticPlaceholder, typewriterPrefix, typewriterPhrases };
}
